import React from 'react';

import cx from 'classnames';

import styles from './overflowEllipsis.module.less';

export type OverflowEllipsisProps = {
  lines?: number;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * Provides up to N lines of text, ending in an ellipsis.
 */
export const OverflowEllipsis = React.forwardRef<HTMLDivElement, OverflowEllipsisProps>(
  (props, ref) => {
    const { lines = 3, className, children, style: styleFromProps = {}, ...rest } = props;

    const style = {
      ...styleFromProps,
      WebkitLineClamp: lines,
    };

    return (
      <div className={cx(styles.overflowEllipsis, className)} style={style} {...rest} ref={ref}>
        {children}
      </div>
    );
  }
);
